import * as React from 'react';

const ArenaVsSVGBackground: React.FC<{}> = () => {
  return (
    <svg xmlnsXlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" width={381} height={302}>
      <g transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
        <use height="186.2" transform="matrix(1.0, 0.0, 0.0, 1.0, 3.0, 1.95)" width="175.05" xlinkHref="#sprite0" />
        <use height="180.9" transform="matrix(1.0, 0.0, 0.0, 1.0, 6.05, 4.75)" width="169.5" xlinkHref="#shape1" />
        <use height="190.1" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="181.05" xlinkHref="#sprite1" />
        <use height="186.2" transform="matrix(1.0, 0.0, 0.0, 1.0, 203.05, 1.95)" width="175.05" xlinkHref="#sprite2" />
        <use height="181.45" transform="matrix(1.0, 0.0, 0.0, 1.0, 205.55, 4.45)" width="171.8" xlinkHref="#shape4" />
        <use height="190.1" transform="matrix(1.0, 0.0, 0.0, 1.0, 200.05, 0.0)" width="181.05" xlinkHref="#sprite1" />
        <use height="22.9" transform="matrix(1.0, 0.0, 0.0, 1.0, 23.25, 7.1)" width="133.7" xlinkHref="#sprite3" />
        <use height="23.9" transform="matrix(1.0, 0.0, 0.0, 1.0, 22.75, 6.6)" width="134.7" xlinkHref="#shape6" />
        <use height="22.9" transform="matrix(1.0, 0.0, 0.0, 1.0, 224.85, 7.1)" width="133.7" xlinkHref="#sprite4" />
        <use height="23.9" transform="matrix(1.0, 0.0, 0.0, 1.0, 224.35, 6.6)" width="134.7" xlinkHref="#shape8" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 7.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 167.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 17.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 27.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 37.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 47.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 57.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 67.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 77.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 87.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 97.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 107.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 117.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 127.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 137.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 147.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 157.5, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="62.4" transform="matrix(1.0, 0.0, 0.0, 1.0, 1.2, 200.05)" width="178.65" xlinkHref="#shape10" />
        <use height="62.4" transform="matrix(1.0, 0.0, 0.0, 1.0, 1.2, 200.05)" width="178.65" xlinkHref="#sprite6" />
        <use height="65.55" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 198.45)" width="181.05" xlinkHref="#sprite7" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 7.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 167.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 17.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 27.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 37.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 47.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 57.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 67.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 77.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 87.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 97.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 107.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 117.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 127.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 137.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 147.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 157.5, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 207.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 367.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 217.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 227.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 237.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 247.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 257.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 267.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 277.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 287.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 297.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 307.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 317.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 327.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 337.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 347.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 357.55, 220.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="62.4" transform="matrix(1.0, 0.0, 0.0, 1.0, 201.25, 200.05)" width="178.65" xlinkHref="#shape10" />
        <use height="62.4" transform="matrix(1.0, 0.0, 0.0, 1.0, 201.25, 200.05)" width="178.65" xlinkHref="#sprite6" />
        <use height="65.55" transform="matrix(1.0, 0.0, 0.0, 1.0, 200.05, 198.45)" width="181.05" xlinkHref="#sprite7" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 207.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 367.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 217.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 227.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 237.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 247.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 257.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 267.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 277.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 287.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 297.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 307.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 317.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 327.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 337.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 347.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 357.55, 240.95)" width="6.0" xlinkHref="#sprite5" />
        {/* <use height="32.0" id="btn_PK" transform="matrix(1.0, 0.0, 0.0, 1.0, 97.0, 270.05)" width="186.7" xlinkHref="#button0"/> */}
        <use height="14.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 152.4, 204.05)" width="14.95" xlinkHref="#sprite10" />
        <use
          height="18.5"
          id="txt_TargetOrderValue"
          transform="matrix(1.0, 0.0, 0.0, 1.0, 257.45, 203.55)"
          width="48.55"
          xlinkHref="#text0"
        />
        <use height="14.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 352.45, 204.05)" width="14.95" xlinkHref="#sprite10" />
        <use height="18.5" id="txt_SelfOrder" transform="matrix(1.0, 0.0, 0.0, 1.0, 7.7, 202.55)" width="57.8" xlinkHref="#text1" />
        <use height="18.5" id="txt_SelfWin" transform="matrix(1.0, 0.0, 0.0, 1.0, 7.7, 222.55)" width="58.3" xlinkHref="#text2" />
        <use height="18.5" id="txt_SelfScore" transform="matrix(1.0, 0.0, 0.0, 1.0, 7.7, 243.0)" width="43.0" xlinkHref="#text3" />
        <use height="18.5" id="txt_SelfOrderValue" transform="matrix(1.0, 0.0, 0.0, 1.0, 59.5, 203.05)" width="43.5" xlinkHref="#text4" />
        <use height="18.5" id="txt_SelfCall" transform="matrix(1.0, 0.0, 0.0, 1.0, 95.5, 203.05)" width="43.0" xlinkHref="#text5" />
        <use height="18.5" id="txt_SelfWinValue" transform="matrix(1.0, 0.0, 0.0, 1.0, 59.2, 222.55)" width="55.95" xlinkHref="#text6" />
        <use height="18.5" id="txt_SelfScoreValue" transform="matrix(1.0, 0.0, 0.0, 1.0, 52.0, 243.05)" width="117.95" xlinkHref="#text7" />
        <use height="18.5" id="txt_SelfName" transform="matrix(1.0, 0.0, 0.0, 1.0, 26.0, 9.6)" width="128.0" xlinkHref="#text8" />
        <use height="18.5" id="txt_TargetName" transform="matrix(1.0, 0.0, 0.0, 1.0, 227.0, 9.1)" width="129.0" xlinkHref="#text9" />
        <use height="18.5" id="txt_TargetOrder" transform="matrix(1.0, 0.0, 0.0, 1.0, 205.15, 202.55)" width="58.85" xlinkHref="#text10" />
        <use height="18.5" id="txt_TargetScore" transform="matrix(1.0, 0.0, 0.0, 1.0, 208.15, 244.0)" width="43.0" xlinkHref="#text11" />
        <use height="18.5" id="txt_TargetWin" transform="matrix(1.0, 0.0, 0.0, 1.0, 208.15, 223.05)" width="62.35" xlinkHref="#text12" />
        <use height="18.5" id="txt_TargetCall" transform="matrix(1.0, 0.0, 0.0, 1.0, 295.45, 203.55)" width="43.0" xlinkHref="#text13" />
        <use
          height="18.5"
          id="txt_TargetWinValue"
          transform="matrix(1.0, 0.0, 0.0, 1.0, 259.65, 222.55)"
          width="55.95"
          xlinkHref="#text14"
        />
        <use
          height="18.5"
          id="txt_TargetScoreValue"
          transform="matrix(1.0, 0.0, 0.0, 1.0, 252.45, 244.05)"
          width="117.95"
          xlinkHref="#text15"
        />
        <use height="152.5" transform="matrix(1.0, 0.0, 0.0, 1.0, 7.5, 32.95)" width="166.0" xlinkHref="#sprite11" />
        <use height="152.5" transform="matrix(1.0, 0.0, 0.0, 1.0, 207.5, 32.95)" width="166.0" xlinkHref="#sprite11" />
        <use height="0.0" id="clip_SelfRank" transform="matrix(1.0, 0.0, 0.0, 1.0, 134.5, 204.0)" width="0.0" xlinkHref="#sprite12" />
        <use height="0.0" id="clip_TargetRank" transform="matrix(1.0, 0.0, 0.0, 1.0, 333.95, 203.5)" width="0.0" xlinkHref="#sprite12" />
        <use height="0.0" id="clip_SelfIcon" transform="matrix(1.0, 0.0, 0.0, 1.0, 90.0, 102.85)" width="0.0" xlinkHref="#sprite12" />
        <use height="0.0" id="clip_TargetIcon" transform="matrix(1.0, 0.0, 0.0, 1.0, 293.95, 102.8)" width="0.0" xlinkHref="#sprite12" />
        <use height="69.15" transform="matrix(0.965, -0.2591, 0.2591, 0.965, 132.0, 65.75)" width="60.95" xlinkHref="#sprite13" />
        <use height="66.6" transform="matrix(0.9885, 0.1482, -0.1482, 0.9885, 198.8827, 70.8098)" width="40.5" xlinkHref="#sprite14" />
      </g>
      <defs>
        <g id="sprite0" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="186.2" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="175.05" xlinkHref="#shape0" />
        </g>
        <g id="shape0" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M162.55 1.25 L162.55 1.3 Q163.0 12.5 175.05 14.4 L175.05 171.8 Q163.0 173.7 162.55 184.9 L162.55 184.95 162.4 186.2 12.65 186.2 12.5 184.95 12.5 184.9 Q12.05 173.7 0.0 171.8 L0.0 14.4 Q12.05 12.5 12.5 1.3 L12.5 1.25 12.65 0.0 162.4 0.0 162.55 1.25"
            fill="url(#gradient0)"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <linearGradient
          gradientTransform="matrix(0.0962, 0.1063, -0.0841, 0.0761, 87.5, 93.1)"
          gradientUnits="userSpaceOnUse"
          id="gradient0"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.12549019607843137" stopColor="#e76300" />
          <stop offset="0.42745098039215684" stopColor="#f5b800" />
          <stop offset="0.611764705882353" stopColor="#f5b800" />
          <stop offset="0.9294117647058824" stopColor="#e76300" />
        </linearGradient>
        <g id="shape1" transform="matrix(1.0, 0.0, 0.0, 1.0, -6.05, -4.75)">
          <path
            d="M162.9 185.65 L81.05 185.65 81.05 90.85 175.55 90.85 175.55 171.25 Q163.5 173.15 163.05 184.35 L163.05 184.4 162.9 185.65"
            fill="url(#gradient1)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M18.7 4.75 L100.55 4.75 100.55 99.55 6.05 99.55 6.05 19.15 Q18.1 17.25 18.55 6.05 L18.55 6.0 18.7 4.75"
            fill="url(#gradient2)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M173.55 94.7 L175.05 94.7 175.05 171.05 Q163.0 172.95 162.55 184.15 L162.55 184.2 162.4 185.45 77.5 185.45 77.5 183.95 160.9 183.95 161.05 182.7 161.05 182.65 Q161.5 171.45 173.55 169.55 L173.55 94.7"
            fill="url(#gradient3)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M103.6 4.75 L103.6 6.25 20.2 6.25 20.05 7.5 20.05 7.55 Q19.6 18.75 7.55 20.65 L7.55 95.5 6.05 95.5 6.05 19.15 Q18.1 17.25 18.55 6.05 L18.55 6.0 18.7 4.75 103.6 4.75"
            fill="url(#gradient4)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M103.6 185.45 L18.7 185.45 18.55 184.2 18.55 184.15 Q18.1 172.95 6.05 171.05 L6.05 94.7 7.55 94.7 7.55 169.55 Q19.6 171.45 20.05 182.65 L20.05 182.7 20.2 183.95 103.6 183.95 103.6 185.45"
            fill="url(#gradient5)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M175.05 19.15 L175.05 95.5 173.55 95.5 173.55 20.65 Q161.5 18.75 161.05 7.55 L161.05 7.5 160.9 6.25 77.5 6.25 77.5 4.75 162.4 4.75 162.55 6.0 162.55 6.05 Q163.0 17.25 175.05 19.15"
            fill="url(#gradient6)"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <radialGradient
          cx="0"
          cy="0"
          fx="25.6"
          fy="0"
          gradientTransform="matrix(0.1155, 0.0, 0.0, 0.1155, 176.1, 185.85)"
          gradientUnits="userSpaceOnUse"
          id="gradient1"
          r="819.2"
          spreadMethod="pad">
          <stop offset="0.1803921568627451" stopColor="#ffe9b9" stopOpacity="0.4" />
          <stop offset="1.0" stopColor="#ffe9b9" stopOpacity="0.0" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          fx="25.6"
          fy="0"
          gradientTransform="matrix(-0.1155, 0.0, 0.0, -0.1155, 5.5, 4.55)"
          gradientUnits="userSpaceOnUse"
          id="gradient2"
          r="819.2"
          spreadMethod="pad">
          <stop offset="0.1803921568627451" stopColor="#ffe9b9" stopOpacity="0.4" />
          <stop offset="1.0" stopColor="#ffe9b9" stopOpacity="0.0" />
        </radialGradient>
        <linearGradient
          gradientTransform="matrix(-0.017, -0.0168, 0.0389, -0.0392, 149.3, 160.95)"
          gradientUnits="userSpaceOnUse"
          id="gradient3"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffe9b9" />
          <stop offset="1.0" stopColor="#ffe9b9" stopOpacity="0.0" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.017, 0.0168, -0.0389, 0.0392, 31.8, 29.25)"
          gradientUnits="userSpaceOnUse"
          id="gradient4"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffe9b9" stopOpacity="0.6" />
          <stop offset="1.0" stopColor="#ffe9b9" stopOpacity="0.0" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.017, -0.0168, -0.0389, -0.0392, 31.8, 160.95)"
          gradientUnits="userSpaceOnUse"
          id="gradient5"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffe9b9" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#ffe9b9" stopOpacity="0.0" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(-0.017, 0.0168, 0.0389, 0.0392, 149.3, 29.25)"
          gradientUnits="userSpaceOnUse"
          id="gradient6"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffe9b9" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#ffe9b9" stopOpacity="0.0" />
        </linearGradient>
        <g id="sprite1" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="190.1" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="181.05" xlinkHref="#shape2" />
        </g>
        <g id="shape2" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M165.55 186.9 L165.55 186.85 Q166.0 175.65 178.05 173.75 L178.05 16.35 Q166.0 14.45 165.55 3.25 L165.55 3.2 165.4 1.95 15.65 1.95 15.5 3.2 15.5 3.25 Q15.05 14.45 3.0 16.35 L3.0 173.75 Q15.05 175.65 15.5 186.85 L15.5 186.9 15.65 188.15 165.4 188.15 165.55 186.9 M168.45 0.0 Q169.7 11.5 181.05 12.9 L181.05 177.2 Q169.7 178.6 168.45 190.1 L12.6 190.1 Q11.35 178.6 0.0 177.2 L0.0 12.9 Q11.35 11.5 12.6 0.0 L168.45 0.0"
            fill="#ffc600"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M165.55 186.9 L165.4 188.15 15.65 188.15 15.5 186.9 165.55 186.9 M15.5 3.2 L15.65 1.95 165.4 1.95 165.55 3.2 15.5 3.2"
            fill="#bc8400"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <g id="sprite2" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="186.2" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="175.05" xlinkHref="#shape3" />
        </g>
        <g id="shape3" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M162.55 1.25 L162.55 1.3 Q163.0 12.5 175.05 14.4 L175.05 171.8 Q163.0 173.7 162.55 184.9 L162.55 184.95 162.4 186.2 12.65 186.2 12.5 184.95 12.5 184.9 Q12.05 173.7 0.0 171.8 L0.0 14.4 Q12.05 12.5 12.5 1.3 L12.5 1.25 12.65 0.0 162.4 0.0 162.55 1.25"
            fill="url(#gradient7)"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <linearGradient
          gradientTransform="matrix(7.0E-4, 0.1293, -0.1133, 6.0E-4, 87.5, 93.1)"
          gradientUnits="userSpaceOnUse"
          id="gradient7"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.10196078431372549" stopColor="#3133ef" />
          <stop offset="0.4627450980392157" stopColor="#2eaeff" />
          <stop offset="0.5254901960784314" stopColor="#2eaeff" />
          <stop offset="0.8666666666666667" stopColor="#3133ef" />
        </linearGradient>
        <g id="shape4" transform="matrix(1.0, 0.0, 0.0, 1.0, -205.55, -4.45)">
          <path
            d="M218.2 4.45 L300.05 4.45 300.05 99.25 205.55 99.25 205.55 18.85 Q217.6 16.95 218.05 5.75 L218.05 5.7 218.2 4.45"
            fill="url(#gradient8)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M362.9 185.75 L281.05 185.75 281.05 90.95 375.55 90.95 375.55 171.35 Q363.5 173.25 363.05 184.45 L363.05 184.5 362.9 185.75"
            fill="url(#gradient9)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M303.1 4.45 L303.1 5.95 219.7 5.95 219.55 7.2 219.55 7.25 Q219.1 18.45 207.05 20.35 L207.05 95.2 205.55 95.2 205.55 18.85 Q217.6 16.95 218.05 5.75 L218.05 5.7 218.2 4.45 303.1 4.45"
            fill="url(#gradient10)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M361.65 5.95 L278.25 5.95 278.25 4.45 363.15 4.45 363.3 5.7 363.3 5.75 Q363.75 16.95 375.8 18.85 378.95 57.05 375.8 95.2 L374.3 95.2 374.3 20.35 Q362.25 18.45 361.8 7.25 L361.8 7.2 361.65 5.95"
            fill="url(#gradient11)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M207.05 95.15 L207.05 170.0 Q219.1 171.9 219.55 183.1 L219.55 183.15 219.7 184.4 303.1 184.4 303.1 185.9 218.2 185.9 218.05 184.65 218.05 184.6 Q217.6 173.4 205.55 171.5 L205.55 95.15 207.05 95.15"
            fill="url(#gradient12)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M278.25 185.9 L278.25 184.4 361.65 184.4 361.8 183.15 361.8 183.1 Q362.25 171.9 374.3 170.0 L374.3 95.15 375.8 95.15 375.8 171.5 Q363.75 173.4 363.3 184.6 L363.3 184.65 363.15 185.9 278.25 185.9"
            fill="url(#gradient13)"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <radialGradient
          cx="0"
          cy="0"
          fx="25.6"
          fy="0"
          gradientTransform="matrix(-0.1155, 0.0, 0.0, -0.1155, 205.0, 4.25)"
          gradientUnits="userSpaceOnUse"
          id="gradient8"
          r="819.2"
          spreadMethod="pad">
          <stop offset="0.1803921568627451" stopColor="#b9ffd2" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#b9ffd2" stopOpacity="0.0" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          fx="25.6"
          fy="0"
          gradientTransform="matrix(0.1155, 0.0, 0.0, 0.1155, 376.1, 185.95)"
          gradientUnits="userSpaceOnUse"
          id="gradient9"
          r="819.2"
          spreadMethod="pad">
          <stop offset="0.1803921568627451" stopColor="#b9ffd2" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#b9ffd2" stopOpacity="0.0" />
        </radialGradient>
        <linearGradient
          gradientTransform="matrix(0.0231, 0.0244, -0.0402, 0.038, 230.3, 31.3)"
          gradientUnits="userSpaceOnUse"
          id="gradient10"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#b9ffd2" stopOpacity="0.6" />
          <stop offset="1.0" stopColor="#b9ffd2" stopOpacity="0.0" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(-0.0231, 0.0244, 0.0402, 0.038, 351.05, 31.3)"
          gradientUnits="userSpaceOnUse"
          id="gradient11"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#b9ffd2" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#b9ffd2" stopOpacity="0.0" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0231, -0.0244, -0.0402, -0.038, 230.3, 159.05)"
          gradientUnits="userSpaceOnUse"
          id="gradient12"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#b9ffd2" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#b9ffd2" stopOpacity="0.0" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(-0.0231, -0.0244, 0.0402, -0.038, 351.05, 159.05)"
          gradientUnits="userSpaceOnUse"
          id="gradient13"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#b9ffd2" stopOpacity="0.6" />
          <stop offset="1.0" stopColor="#b9ffd2" stopOpacity="0.0" />
        </linearGradient>
        <g id="sprite3" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="22.9" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="133.7" xlinkHref="#shape5" />
        </g>
        <g id="shape5" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M127.7 0.0 Q133.7 0.0 133.7 5.7 L133.7 17.2 Q133.7 22.9 127.7 22.9 L5.95 22.9 Q0.0 22.9 0.0 17.2 L0.0 5.7 Q0.0 0.0 5.95 0.0 L127.7 0.0"
            fill="#603400"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <g id="shape6" transform="matrix(1.0, 0.0, 0.0, 1.0, -22.75, -6.6)">
          <path
            d="M29.2 7.6 Q23.75 7.6 23.75 12.8 L23.75 24.3 Q23.75 29.5 29.2 29.5 L150.95 29.5 Q156.45 29.5 156.45 24.3 L156.45 12.8 Q156.45 7.6 150.95 7.6 L29.2 7.6 M22.75 12.8 Q22.75 6.6 29.2 6.6 L150.95 6.6 Q157.45 6.6 157.45 12.8 L157.45 24.3 Q157.45 30.5 150.95 30.5 L29.2 30.5 Q22.75 30.5 22.75 24.3 L22.75 12.8"
            fill="#ffcd4f"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <g id="sprite4" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="22.9" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="133.7" xlinkHref="#shape7" />
        </g>
        <g id="shape7" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M127.7 0.0 Q133.7 0.0 133.7 5.7 L133.7 17.2 Q133.7 22.9 127.7 22.9 L5.95 22.9 Q0.0 22.9 0.0 17.2 L0.0 5.7 Q0.0 0.0 5.95 0.0 L127.7 0.0"
            fill="#003e81"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <g id="shape8" transform="matrix(1.0, 0.0, 0.0, 1.0, -224.35, -6.6)">
          <path
            d="M352.55 6.6 Q359.05 6.6 359.05 12.8 L359.05 24.3 Q359.05 30.5 352.55 30.5 L230.8 30.5 Q224.35 30.5 224.35 24.3 L224.35 12.8 Q224.35 6.6 230.8 6.6 L352.55 6.6 M352.55 29.5 Q358.05 29.5 358.05 24.3 L358.05 12.8 Q358.05 7.6 352.55 7.6 L230.8 7.6 Q225.35 7.6 225.35 12.8 L225.35 24.3 Q225.35 29.5 230.8 29.5 L352.55 29.5"
            fill="#1174fe"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <g id="sprite5" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="1.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="6.0" xlinkHref="#shape9" />
        </g>
        <g id="shape9" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path d="M6.0 1.0 L0.0 1.0 0.0 0.0 6.0 0.0 6.0 1.0" fill="#4bffff" fillRule="evenodd" stroke="none" />
        </g>
        <g id="shape10" transform="matrix(1.0, 0.0, 0.0, 1.0, -201.25, -200.05)">
          <path
            d="M204.1 203.5 L207.75 200.05 373.65 200.05 375.6 202.9 Q376.95 204.6 379.9 207.3 L379.9 251.6 Q379.9 262.45 370.4 262.45 L210.8 262.45 Q201.25 262.45 201.25 251.6 L201.25 206.15 204.1 203.5"
            fill="#00ccff"
            fillOpacity="0.101960786"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <g id="sprite6" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="62.4" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="178.65" xlinkHref="#shape11" />
        </g>
        <g id="shape11" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M174.35 2.85 Q175.7 4.55 178.65 7.25 L178.65 51.55 Q178.65 62.4 169.15 62.4 L9.55 62.4 Q0.0 62.4 0.0 51.55 L0.0 6.1 2.85 3.45 6.5 0.0 172.4 0.0 174.35 2.85"
            fill="#00ccff"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <g id="sprite7" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="65.55" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="181.05" xlinkHref="#shape12" />
        </g>
        <g id="shape12" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M172.1 2.6 L8.95 2.6 Q4.65 4.9 2.5 9.55 L2.5 56.0 Q4.65 60.65 8.95 62.95 L172.1 62.95 Q176.4 60.65 178.55 56.0 L178.55 9.55 Q176.4 4.9 172.1 2.6 M181.05 5.7 L181.05 59.85 Q178.55 63.2 175.65 65.55 L5.4 65.55 Q2.5 63.2 0.0 59.85 L0.0 5.7 Q2.5 2.35 5.4 0.0 L175.65 0.0 Q178.55 2.35 181.05 5.7"
            fill="#f1dc0e"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <g id="button0" transform="matrix(1.0, 0.0, 0.0, 1.0, -0.5, -1.0)">
          <use height="25.3" transform="matrix(1.0, 0.0, 0.0, 1.0, 11.9, 4.35)" width="164.3" xlinkHref="#sprite8" />
          <use height="32.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.5, 1.0)" width="186.7" xlinkHref="#shape14" />
          <use height="13.65" transform="matrix(1.0, 0.0, 0.0, 1.0, 68.55, 10.2)" width="50.6" xlinkHref="#sprite9" />
        </g>
        <g id="sprite8" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="25.3" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="164.3" xlinkHref="#shape13" />
        </g>
        <g id="shape13" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M51.05 0.0 L51.05 25.3 7.6 25.3 Q8.9 17.3 0.0 13.55 7.75 10.35 7.75 0.0 L51.05 0.0"
            fill="url(#gradient14)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M103.6 0.0 L155.4 0.0 Q155.9 9.1 164.3 13.4 L164.3 13.65 Q155.25 16.5 155.5 25.3 L103.6 25.3 103.6 0.0"
            fill="url(#gradient15)"
            fillRule="evenodd"
            stroke="none"
          />
          <path d="M103.6 25.3 L51.1 25.3 51.1 0.0 103.6 0.0 103.6 25.3" fill="url(#gradient16)" fillRule="evenodd" stroke="none" />
        </g>
        <linearGradient
          gradientTransform="matrix(0.0495, 0.0, 0.0, 0.0154, 57.3, 12.65)"
          gradientUnits="userSpaceOnUse"
          id="gradient14"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#f57500" />
          <stop offset="1.0" stopColor="#d95200" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0495, 0.0, 0.0, 0.0154, 107.3, 12.65)"
          gradientUnits="userSpaceOnUse"
          id="gradient15"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#f57500" />
          <stop offset="1.0" stopColor="#d95200" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(2.5987, 0.0, 0.0, 0.0154, 379.2, 12.65)"
          gradientUnits="userSpaceOnUse"
          id="gradient16"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#f57500" />
          <stop offset="1.0" stopColor="#d95200" />
        </linearGradient>
        <g id="shape14" transform="matrix(1.0, 0.0, 0.0, 1.0, -0.5, -1.0)">
          <path
            d="M18.0 12.4 Q19.75 8.3 19.75 5.25 L19.75 4.65 72.15 4.65 72.35 6.65 Q72.35 13.9 61.8 19.0 51.25 24.15 36.35 24.15 L27.0 23.6 21.1 22.55 17.65 21.65 17.6 21.6 14.9 19.35 12.8 18.15 13.2 17.9 15.6 15.95 18.0 12.4"
            fill="url(#gradient17)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M168.0 4.95 Q168.0 6.1 169.05 9.15 170.05 12.05 170.5 12.55 172.0 14.45 175.7 17.2 L176.25 17.6 Q173.0 19.05 170.7 21.25 167.5 24.35 167.5 28.05 L167.7 29.4 128.75 29.4 Q125.35 25.95 125.35 21.85 125.35 14.6 135.9 9.45 146.45 4.35 161.35 4.35 L168.0 4.65 168.0 4.95"
            fill="url(#gradient18)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M177.6 11.25 Q177.65 5.7 182.75 6.8 L183.05 6.85 Q186.2 8.0 186.35 10.7 186.45 11.6 186.15 12.65 L185.9 13.55 Q183.35 17.45 178.75 17.1 L178.45 17.1 178.15 17.0 Q168.9 14.7 166.95 4.0 L166.8 3.05 20.9 3.05 20.75 4.0 Q18.8 14.7 9.55 17.0 L9.25 17.1 8.95 17.1 Q4.35 17.45 1.8 13.55 L1.55 12.65 Q1.25 11.6 1.35 10.7 1.5 8.0 4.65 6.85 L4.95 6.8 Q10.05 5.7 10.1 11.25 8.05 12.65 6.65 11.45 4.95 11.0 5.4 12.35 8.4 15.3 11.35 11.55 L11.35 11.5 11.45 11.5 11.5 11.45 11.8 11.25 11.6 11.35 Q15.8 8.55 16.75 1.0 L170.95 1.0 Q171.9 8.55 176.1 11.35 L175.9 11.25 176.2 11.45 176.25 11.5 176.35 11.5 176.35 11.55 Q179.3 15.3 182.3 12.35 182.75 11.0 181.05 11.45 179.65 12.65 177.6 11.25 M184.3 18.15 L185.55 19.15 Q186.05 19.85 186.0 21.1 L185.45 22.7 184.8 23.5 Q183.65 24.7 182.2 24.6 180.75 24.45 180.05 23.85 179.35 23.25 179.3 21.6 179.25 19.9 180.5 18.9 181.75 17.9 183.25 17.95 L184.3 18.15 M16.75 31.0 Q16.75 28.65 16.2 26.7 14.85 22.55 9.35 19.05 12.6 17.75 14.65 16.5 19.7 22.1 20.75 26.95 L20.9 27.9 166.8 27.9 166.95 26.95 Q168.0 22.1 173.05 16.5 175.1 17.75 178.35 18.55 172.85 22.55 171.5 26.7 170.95 28.65 170.95 31.0 L16.75 31.0 M2.25 22.7 Q1.75 21.9 1.7 21.1 1.65 19.85 2.15 19.15 2.6 18.45 3.4 18.15 L4.45 17.95 Q5.95 17.9 7.2 18.9 8.45 19.9 8.4 21.6 8.35 23.25 7.65 23.85 6.95 24.45 5.5 24.6 4.05 24.7 2.9 23.5 L2.25 22.7"
            fill="#ffc600"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M20.75 4.0 L20.9 3.05 166.8 3.05 166.95 4.0 139.2 4.0 134.55 4.0 77.2 4.0 20.75 4.0"
            fill="#b88109"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M134.55 6.9 L24.4 6.9 Q23.1 13.2 19.0 16.65 23.5 20.65 23.5 26.0 L134.55 26.0 134.55 26.95 21.9 26.95 Q19.95 20.2 15.45 16.0 20.7 12.35 21.85 6.0 L77.2 6.0 134.55 6.0 134.55 6.9"
            fill="#fce5b3"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M177.6 11.25 Q179.65 12.65 181.05 11.45 182.75 11.0 182.3 12.35 179.3 15.3 176.35 11.55 L177.0 11.85 177.35 11.7 177.6 11.25 M11.35 11.55 Q8.4 15.3 5.4 12.35 4.95 11.0 6.65 11.45 8.05 12.65 10.1 11.25 10.05 11.6 10.35 11.7 L10.7 11.85 11.35 11.55"
            fill="#522405"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M166.8 27.9 L20.9 27.9 21.9 26.95 134.55 26.95 139.2 26.95 165.8 26.95 166.8 27.9"
            fill="#8e4e11"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M177.25 21.5 Q171.45 26.05 172.4 33.0 L18.05 33.0 16.75 31.0 170.95 31.0 Q170.95 28.65 171.5 26.7 174.75 21.95 177.25 21.5"
            fill="#350000"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M172.25 16.0 L173.05 16.5 Q168.0 22.1 166.95 26.95 L166.8 27.9 165.8 26.95 Q167.75 20.2 172.25 16.0"
            fill="#9a510d"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M1.35 10.7 Q1.25 11.6 1.55 12.65 L1.8 13.55 Q4.35 17.45 8.95 17.1 L9.25 17.1 9.55 17.0 Q18.8 14.7 20.75 4.0 L77.2 4.0 77.2 6.0 21.85 6.0 Q20.7 12.35 15.45 16.0 L14.65 16.5 Q12.6 17.75 9.35 19.05 14.85 22.55 16.2 26.7 12.95 21.95 10.45 21.5 8.45 27.35 4.2 25.75 2.45 24.9 2.25 22.7 L2.9 23.5 Q4.05 24.7 5.5 24.6 6.95 24.45 7.65 23.85 8.35 23.25 8.4 21.6 8.45 19.9 7.2 18.9 5.95 17.9 4.45 17.95 L3.4 18.15 Q-1.1 15.3 1.35 10.7"
            fill="url(#gradient19)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M20.9 27.9 L20.75 26.95 Q19.7 22.1 14.65 16.5 L15.45 16.0 Q19.95 20.2 21.9 26.95 L20.9 27.9"
            fill="url(#gradient20)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M166.95 4.0 Q168.9 14.7 178.15 17.0 L178.45 17.1 178.75 17.1 Q183.35 17.45 185.9 13.55 L186.15 12.65 Q186.45 11.6 186.35 10.7 188.8 15.3 184.3 18.15 L183.25 17.95 Q181.75 17.9 180.5 18.9 179.25 19.9 179.3 21.6 179.35 23.25 180.05 23.85 180.75 24.45 182.2 24.6 183.65 24.7 184.8 23.5 L185.45 22.7 Q185.25 24.9 183.5 25.75 179.25 27.35 177.25 21.5 174.75 21.95 171.5 26.7 172.85 22.55 178.35 18.55 175.1 17.75 173.05 16.5 L172.25 16.0 Q167.0 12.35 165.85 6.0 L139.2 6.0 139.2 4.0 166.95 4.0"
            fill="url(#gradient21)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M139.2 26.0 L164.2 26.0 Q164.2 20.65 168.7 16.65 164.6 13.2 163.3 6.9 L139.2 6.9 139.2 6.0 165.85 6.0 Q167.0 12.35 172.25 16.0 167.75 20.2 165.8 26.95 L139.2 26.95 139.2 26.0"
            fill="url(#gradient22)"
            fillRule="evenodd"
            stroke="none"
          />
          <path d="M139.2 4.0 L139.2 6.0 134.55 6.0 134.55 4.0 139.2 4.0" fill="url(#gradient23)" fillRule="evenodd" stroke="none" />
          <path d="M134.55 4.0 L134.55 6.0 77.2 6.0 77.2 4.0 134.55 4.0" fill="url(#gradient24)" fillRule="evenodd" stroke="none" />
          <path
            d="M139.2 6.9 L134.55 6.9 134.55 6.0 139.2 6.0 139.2 6.9 M134.55 26.0 L139.2 26.0 139.2 26.95 134.55 26.95 134.55 26.0"
            fill="url(#gradient25)"
            fillRule="evenodd"
            stroke="none"
          />
          <path d="M60.7 6.4 L77.8 6.4 56.65 26.9 39.55 26.9 60.7 6.4" fill="url(#gradient26)" fillRule="evenodd" stroke="none" />
          <path d="M49.3 6.4 L28.15 26.9 22.75 26.9 43.9 6.4 49.3 6.4" fill="url(#gradient27)" fillRule="evenodd" stroke="none" />
          <path d="M81.85 6.4 L85.45 6.4 64.3 26.9 60.7 26.9 81.85 6.4" fill="url(#gradient28)" fillRule="evenodd" stroke="none" />
          <path
            d="M124.5 26.95 L145.65 6.45 157.95 6.45 136.8 26.95 124.5 26.95"
            fill="url(#gradient29)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M140.5 26.95 L161.65 6.45 165.65 6.45 144.5 26.95 140.5 26.95"
            fill="url(#gradient30)"
            fillRule="evenodd"
            stroke="none"
          />
          <path
            d="M168.8 16.55 L170.6 17.9 169.55 19.15 Q168.0 21.2 167.15 23.3 L163.35 26.95 151.05 26.95 165.55 12.95 166.25 13.75 168.8 16.55"
            fill="url(#gradient31)"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(0.0458, 0.0, 0.0, 0.0229, 36.35, 6.65)"
          gradientUnits="userSpaceOnUse"
          id="gradient17"
          r="819.2"
          spreadMethod="pad">
          <stop offset="0.0" stopColor="#e3ae6d" stopOpacity="0.6" />
          <stop offset="1.0" stopColor="#e3ae6d" stopOpacity="0.0" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="matrix(0.0458, 0.0, 0.0, 0.0229, 161.35, 21.85)"
          gradientUnits="userSpaceOnUse"
          id="gradient18"
          r="819.2"
          spreadMethod="pad">
          <stop offset="0.0" stopColor="#e3ae6d" stopOpacity="0.6" />
          <stop offset="1.0" stopColor="#e3ae6d" stopOpacity="0.0" />
        </radialGradient>
        <linearGradient
          gradientTransform="matrix(-0.0467, 0.0, 0.0, -0.0139, 50.55, 13.9)"
          gradientUnits="userSpaceOnUse"
          id="gradient19"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#8b490f" />
          <stop offset="1.0" stopColor="#330504" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(-0.0022, -0.0038, 0.0063, -0.0036, 19.3, 21.4)"
          gradientUnits="userSpaceOnUse"
          id="gradient20"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#572104" />
          <stop offset="1.0" stopColor="#c7974a" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0127, 0.0, 0.0, -0.0139, 148.4, 16.95)"
          gradientUnits="userSpaceOnUse"
          id="gradient21"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#8b490f" />
          <stop offset="1.0" stopColor="#330504" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0235, 0.0, 0.0, 0.0128, 150.4, 16.3)"
          gradientUnits="userSpaceOnUse"
          id="gradient22"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#fce5b3" />
          <stop offset="1.0" stopColor="#dfb98a" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0656, 0.0, 0.0, -0.0139, 190.65, 16.95)"
          gradientUnits="userSpaceOnUse"
          id="gradient23"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#8b490f" />
          <stop offset="1.0" stopColor="#330504" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(-0.2412, 0.0, 0.0, -0.0139, -60.45, 13.9)"
          gradientUnits="userSpaceOnUse"
          id="gradient24"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#8b490f" />
          <stop offset="1.0" stopColor="#330504" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.1214, 0.0, 0.0, 0.0128, 200.95, 16.3)"
          gradientUnits="userSpaceOnUse"
          id="gradient25"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#fce5b3" />
          <stop offset="1.0" stopColor="#dfb98a" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0, 0.0086, -0.0129, 0.0, 60.1, 16.35)"
          gradientUnits="userSpaceOnUse"
          id="gradient26"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffffff" stopOpacity="0.2509804" />
          <stop offset="1.0" stopColor="#ffffff" stopOpacity="0.050980393" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0, 0.0074, -0.0129, 0.0, 36.4, 15.4)"
          gradientUnits="userSpaceOnUse"
          id="gradient27"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffffff" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#ffffff" stopOpacity="0.101960786" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0, 0.0075, -0.0129, 0.0, 71.25, 15.15)"
          gradientUnits="userSpaceOnUse"
          id="gradient28"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffffff" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#ffffff" stopOpacity="0.101960786" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0, -0.0068, 0.0129, 0.0, 141.4, 16.1)"
          gradientUnits="userSpaceOnUse"
          id="gradient29"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffffff" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#ffffff" stopOpacity="0.101960786" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0, -0.0062, 0.0129, 0.0, 153.0, 19.0)"
          gradientUnits="userSpaceOnUse"
          id="gradient30"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffffff" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#ffffff" stopOpacity="0.101960786" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(0.0, -0.0068, 0.0129, 0.0, 167.95, 16.1)"
          gradientUnits="userSpaceOnUse"
          id="gradient31"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffffff" stopOpacity="0.3019608" />
          <stop offset="1.0" stopColor="#ffffff" stopOpacity="0.101960786" />
        </linearGradient>
        <g id="sprite9" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="13.65" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="50.6" xlinkHref="#shape15" />
        </g>
        <g id="shape15" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M48.5 1.75 L48.95 1.7 49.65 2.0 50.3 2.7 50.6 3.65 50.5 4.5 50.1 5.3 49.45 6.3 48.85 7.2 48.45 8.0 Q48.25 8.45 48.2 9.05 L48.1 9.7 47.85 9.9 47.55 9.85 47.35 9.5 47.3 8.8 47.3 7.95 Q47.3 7.45 47.45 7.05 L47.85 5.8 48.35 4.4 48.5 3.25 48.5 2.45 48.5 1.75 M40.95 4.95 Q40.6 5.0 40.3 5.3 L39.65 5.85 39.15 6.65 39.0 7.25 39.7 7.3 40.6 7.0 41.4 6.35 41.85 5.7 Q42.0 5.25 41.8 5.05 L40.95 4.95 M43.85 4.55 L43.75 5.3 43.3 6.05 42.55 6.7 41.55 7.25 40.5 7.65 39.5 7.9 38.9 8.05 38.8 8.6 38.9 9.2 39.4 9.85 40.3 9.95 41.25 9.6 42.1 9.05 42.55 8.8 42.7 9.0 42.55 9.4 42.0 10.0 41.2 10.65 40.2 11.2 39.0 11.35 38.1 11.05 37.55 10.45 37.25 9.5 37.2 8.35 37.45 7.2 38.05 6.05 39.05 5.05 40.2 4.4 Q40.8 4.1 41.55 3.95 L42.9 3.85 43.6 4.0 43.85 4.55 M47.9 11.1 L48.3 11.95 Q48.4 12.6 48.0 13.05 47.65 13.5 47.2 13.6 L46.35 13.5 46.0 13.1 45.9 12.7 46.05 11.9 46.45 11.1 Q46.75 10.85 47.2 10.85 L47.9 11.1 M35.6 2.95 L35.25 6.9 35.2 8.35 35.1 10.0 34.75 10.9 34.3 11.35 33.8 10.8 33.35 9.9 33.2 9.25 33.2 8.9 33.45 8.45 33.7 7.7 33.95 4.15 33.9 2.7 33.7 0.75 33.75 0.3 34.2 0.3 35.0 0.55 35.7 0.9 36.05 1.4 35.6 2.95 M30.85 1.0 L30.7 1.55 30.3 2.25 30.0 3.05 29.8 3.85 30.35 3.95 30.95 3.85 31.55 3.65 31.95 3.6 32.05 3.8 32.0 4.15 31.65 4.75 31.25 5.05 30.45 5.2 29.7 5.4 Q29.45 5.55 29.35 5.85 L29.15 6.6 29.0 7.5 29.0 8.25 29.3 8.6 29.8 8.5 30.3 8.1 30.7 7.65 31.05 7.05 31.35 6.7 31.45 7.0 31.35 7.7 31.15 8.45 30.8 9.0 30.4 9.55 30.1 10.1 30.15 10.8 30.25 11.25 29.55 11.3 28.9 11.15 28.05 10.7 27.4 9.8 27.2 8.65 27.3 7.85 27.45 7.0 27.7 6.2 27.7 5.7 27.05 5.75 26.3 5.95 26.0 5.85 25.85 5.55 26.05 5.1 26.3 4.65 26.75 4.05 27.15 3.85 27.6 3.95 28.1 3.75 28.35 3.15 28.5 2.3 28.6 1.5 28.6 0.55 Q28.55 0.2 28.65 0.1 L29.1 0.0 29.95 0.25 30.6 0.65 30.85 1.0 M23.6 0.65 L23.85 1.0 23.7 1.55 23.3 2.25 23.0 3.05 22.8 3.85 23.35 3.95 23.95 3.85 24.55 3.65 24.95 3.6 25.05 3.8 25.0 4.15 24.65 4.75 24.25 5.05 23.45 5.2 22.7 5.4 Q22.45 5.55 22.35 5.85 L22.15 6.6 22.0 7.5 22.0 8.25 22.3 8.6 22.8 8.5 23.3 8.1 23.7 7.65 24.05 7.05 24.35 6.7 24.45 7.0 24.35 7.7 24.15 8.45 23.8 9.0 23.4 9.55 23.1 10.1 23.15 10.8 23.25 11.25 22.55 11.3 21.9 11.15 21.05 10.7 20.4 9.8 20.2 8.65 20.3 7.85 20.45 7.0 20.7 6.2 20.7 5.7 20.05 5.75 19.3 5.95 19.0 5.85 18.85 5.55 19.05 5.1 19.3 4.65 19.75 4.05 20.15 3.85 20.6 3.95 21.1 3.75 21.35 3.15 21.5 2.3 21.6 1.5 21.6 0.55 Q21.55 0.2 21.65 0.1 L22.1 0.0 22.95 0.25 23.6 0.65 M15.85 5.3 L15.6 4.7 15.0 4.35 14.2 4.55 13.4 5.15 12.8 5.8 12.3 6.65 11.85 7.8 11.75 8.8 Q11.8 9.2 12.0 9.4 L12.6 9.55 13.55 9.3 14.5 8.75 15.05 8.0 15.75 6.1 15.85 5.3 M16.75 3.75 Q16.9 3.55 17.1 3.5 L17.5 3.65 17.9 4.2 18.0 4.85 17.75 5.2 17.35 5.95 16.9 7.2 16.6 8.4 16.8 8.95 17.1 9.15 17.05 9.55 16.5 10.4 15.7 10.9 14.95 10.7 Q14.5 10.3 14.65 9.85 L14.75 9.0 13.8 10.2 12.75 10.95 11.45 11.25 10.5 11.0 10.0 10.25 Q9.8 9.75 9.95 8.85 10.05 7.95 10.3 7.35 L10.95 6.15 12.05 5.0 Q12.65 4.5 13.35 4.2 L14.85 3.9 15.55 3.9 16.35 4.1 16.75 3.75 M8.9 2.2 L9.05 3.15 8.65 4.3 7.8 4.9 7.1 5.2 7.6 5.35 8.2 5.6 8.75 6.2 9.05 7.35 Q9.05 8.05 8.65 8.55 L7.5 9.5 Q6.8 9.9 5.8 10.15 L3.95 10.55 1.55 10.85 1.5 11.0 1.4 11.2 1.15 11.35 0.7 11.1 0.3 10.4 0.05 9.6 0.0 8.9 0.25 8.5 0.6 7.55 0.85 6.1 1.05 4.65 1.15 3.45 1.3 2.2 1.3 1.4 1.15 0.7 1.15 0.45 1.3 0.25 Q1.4 0.15 1.6 0.15 L2.45 0.35 3.1 0.65 3.35 0.85 4.05 0.85 4.95 0.85 6.25 0.9 7.4 1.1 8.3 1.55 8.9 2.2 M5.7 1.75 L4.4 1.55 3.1 1.55 2.95 2.35 2.5 5.3 3.6 5.15 5.0 4.85 6.3 4.35 7.1 3.55 Q7.35 3.05 7.2 2.7 L6.7 2.1 5.7 1.75 M5.5 5.85 L4.45 5.85 2.4 6.05 2.25 7.25 2.0 8.55 1.75 10.05 3.2 9.85 4.7 9.5 6.2 8.85 7.05 7.95 7.1 6.85 6.5 6.15 5.5 5.85"
            fill="url(#gradient32)"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <linearGradient
          gradientTransform="matrix(0.0, 0.0042, -0.0309, 0.0, 25.45, 6.3)"
          gradientUnits="userSpaceOnUse"
          id="gradient32"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffe89b" />
          <stop offset="1.0" stopColor="#bf5909" />
        </linearGradient>
        <g id="sprite10" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <clipPath id="clipPath0" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
            <use height="14.0" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="14.95" xlinkHref="#shape16" />
          </clipPath>
        </g>
        <g id="shape16" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path d="M14.95 0.0 L14.95 14.0 0.0 14.0 0.0 0.0 14.95 0.0" fill="#ffff00" fillRule="evenodd" stroke="none" />
        </g>
        <g id="sprite11" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <clipPath id="clipPath1" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
            <use height="152.5" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="166.0" xlinkHref="#shape17" />
          </clipPath>
        </g>
        <g id="shape17" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M166.0 137.5 Q164.75 137.55 163.25 138.1 160.1 139.25 157.9 141.95 155.5 145.0 155.5 148.75 155.5 149.85 156.0 151.4 L155.8 152.5 12.0 152.5 12.0 150.75 Q12.0 146.55 9.5 143.1 7.3 140.1 4.0 138.75 1.8 137.85 0.0 138.05 L0.0 0.0 166.0 0.0 166.0 137.5"
            fill="#ffffff"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <g id="sprite13" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <use height="69.15" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)" width="60.95" xlinkHref="#shape18" />
        </g>
        <g id="shape18" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)">
          <path
            d="M60.95 5.35 L39.55 63.4 20.55 69.15 0.0 10.65 20.75 0.0 29.65 36.55 43.05 0.35 60.95 5.35"
            fill="url(#gradient33)"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <linearGradient
          gradientTransform="matrix(0.0, 0.0287, -0.0616, 0.0, 50.5, 34.65)"
          gradientUnits="userSpaceOnUse"
          id="gradient33"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffe854" />
          <stop offset="1.0" stopColor="#ff7607" />
        </linearGradient>
        <g id="sprite14" transform="matrix(1.0, 0.0, 0.0, 1.0, -0.85, -1.4)">
          <use height="66.6" transform="matrix(1.0, 0.0, 0.0, 1.0, 0.85, 1.4)" width="40.5" xlinkHref="#shape19" />
        </g>
        <g id="shape19" transform="matrix(1.0, 0.0, 0.0, 1.0, -0.85, -1.4)">
          <path
            d="M32.5 17.45 Q29.5 17.45 27.7 19.35 26.15 20.85 26.15 22.55 26.15 25.4 29.75 29.75 L36.5 37.85 Q40.1 43.15 40.1 48.2 40.1 57.0 33.5 62.55 26.9 68.0 17.2 68.0 12.8 68.0 8.4 66.8 L0.85 46.4 Q6.5 50.05 11.2 50.05 17.5 50.05 17.5 44.35 17.5 42.25 14.65 38.9 L9.3 32.55 Q6.5 28.1 6.5 23.25 6.5 16.05 12.7 9.65 20.95 1.4 35.8 1.4 L41.35 1.65 39.1 19.25 Q35.5 17.45 32.5 17.45"
            fill="url(#gradient34)"
            fillRule="evenodd"
            stroke="none"
          />
        </g>
        <linearGradient
          gradientTransform="matrix(0.0, 0.0275, -0.0592, 0.0, -7.15, 35.25)"
          gradientUnits="userSpaceOnUse"
          id="gradient34"
          spreadMethod="pad"
          x1="-819.2"
          x2="819.2">
          <stop offset="0.0" stopColor="#ffe854" />
          <stop offset="1.0" stopColor="#ff7607" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ArenaVsSVGBackground;
